/**
 * Прогресс 0…MAX_PROGRESS из положения трека. sticky top: 0.
 */

import { MAX_PROGRESS, clamp } from "./pcScrollConstants";

function readPcProgress(track, sticky) {
    const travel = track.offsetHeight - sticky.offsetHeight;
    if (travel <= 0) return 0;
    const scrolled = -track.getBoundingClientRect().top;
    return clamp(scrolled / travel, 0, 1) * MAX_PROGRESS;
}

export default readPcProgress;
// hooks/pcScroll/readPcProgress.js
